export const RESET_DATA = 'RESET_DATA';
export const RESET_DATA_START = 'RESET_DATA_START';
